
import { IndustryLayout } from "@/components/industry/IndustryLayout";
import { IndustryFAQ } from "@/components/industry/IndustryFAQ";
import { EducationHero } from "@/components/education/HeroSection";
import { BenefitsSection } from "@/components/education/BenefitsSection";
import { ServicesGrid } from "@/components/education/ServicesGrid";
import { SuccessStory } from "@/components/education/SuccessStory";
import { CTASection } from "@/components/education/CTASection";
import { industryFAQs } from "@/data/industry-faqs";

const Education = () => {
  return (
    <IndustryLayout industryName="Education">
      <EducationHero />
      <BenefitsSection />
      <ServicesGrid />
      <IndustryFAQ faqs={industryFAQs["education"]} industryName="Education" />
      <CTASection />
    </IndustryLayout>
  );
};

export default Education;
